import { useAppContext } from "@/providers";

export function ThemeToggle() {
  const { toggleTheme, theme } = useAppContext();
  const isDark = theme === "dark";

  return (
    <button
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggleTheme}
      className="fixed bottom-6 start-6 w-12 h-12 bg-card rounded-full shadow-lg border border-border flex items-center justify-center z-50 hover:scale-110 active:scale-95 transition-all duration-base"
    >
      <span className="material-icons-outlined text-foreground-secondary">
        {isDark ? "light_mode" : "dark_mode"}
      </span>
    </button>
  );
}
